import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=43b6d5b4"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"
import style0 from "./Photos.vue?vue&type=style&index=0&id=43b6d5b4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports